import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { HttpBaseService } from '../../service/http-base.service';
import { ResponseResult } from '../../models/authentication/login';
import { HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from "ngx-spinner";
import { RoutingHelper } from '../../helpers/routinghelper';
import { UserSetting } from '../../models/masters/user.model';
import { domain } from 'process';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  loginForm: FormGroup;
  submitted = false;
  returnUrl: string;
  showValidation: boolean = false;
  public apiURL = null;
  hide: boolean = true;
  confirmHide: boolean = true;
  resetCode: string = '';
  userName: string = '';
  passCode: string = '';
  domain: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private httpService: HttpBaseService,
    private routingHelper: RoutingHelper
  ) {}
  ngOnInit() {
    this.httpService.getAPIURL().subscribe(url => {
      this.apiURL = `${url.API_URL}`;
      this.getUserData();
    });

    this.loginForm = this.createForm('', '');

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  } 

  formControl = new FormControl('', [
    Validators.required
    // Validators.email,
  ]);

  getErrorMessage() {
    return this.formControl.hasError('required')
      ? 'Required field'
      : this.formControl.hasError('email')
        ? 'Not a valid email'
        : '';
  }

  createForm(user, passcode): FormGroup {
    return this.formBuilder.group({
      domain:domain,
      name: user,
      password: '',
      confirmPassword: '',
      code: passcode
    });
  }

  getUserData() {
    var queryparam = this.route.queryParams;
    this.resetCode = queryparam ? queryparam['value']['url'] : null;

    if (this.resetCode != null) {
      this.httpService.get(this.apiURL + 'auth/GetUserNameByURL', { url: this.resetCode }, false).subscribe(res => {
        if (res) {
          let data = res as UserSetting;
          this.userName = data.UserName;
          this.passCode = data.PasswordCode;
          this.loginForm = this.createForm(data.UserName, data.PasswordCode);
          this.spinner.hide();
        }
      });
    }
    else {
      this.spinner.hide();
      this.loginForm = this.createForm('', '')
    }   
  }

  validate(): boolean {
    let result = true;
    
    if (this.loginForm.getRawValue().password != this.loginForm.getRawValue().confirmPassword) {
      this.loginForm.controls['confirmPassword'].setErrors({ 'incorrect': true });
      result = false;
    }
    return result;
  }

  onSubmit() {
    this.submitted = true;
    let validateForm = this.validate();
    if (!validateForm) {
      return;
    }   
    else {

      let user = this.userName != '' ? this.userName : this.loginForm.getRawValue().name;
      let code = this.passCode != '' ? this.passCode : this.loginForm.getRawValue().code;
      let domain = this.domain != '' ? this.domain : this.loginForm.getRawValue().domain;

      const data = new HttpHeaders()
        .set('username', user)
        .set('password', this.loginForm.getRawValue().password)
        .set('code', code)
        .set('domain', domain);

      this.httpService.postWithHeader(this.apiURL + 'auth/ResetPassword', null, data).subscribe(response => {
        var result = response as ResponseResult;
        if (result) {
          this.showValidation = true;
        }
        else {
          this.showValidation = false;
        }
      }, error => {
        if ((error.status === 400 || error.status === 401) || (error.status === 401 && error.statusText == 'Unauthorized')) {
          this.showValidation = false;
          if (this.loginForm) {
            this.loginForm.controls['code'].setErrors({ 'incorrect': true });
            this.loginForm.controls['name'].setErrors({ 'incorrect': true });
          }
          return false;
        }
          this.showValidation = false;
      });
    }
  }
}
